import React from "react"
import "./App.scss"
import Content from "./components/Content/Content"

function App() {
  return (
    <div className="App">
      <Content />
    </div>
  )
}

export default App
